"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSubject = void 0;
const ecce_1 = require("ecce");
const hooks_1 = require("preact/hooks");
const util_1 = require("ecce/dist/util");
const useRerender = () => (0, hooks_1.useReducer)(() => ({}), {})[1];
const useSubject = (subject, keyOrOptions, options) => {
    const rerender = useRerender();
    (0, hooks_1.useLayoutEffect)(() => {
        // Observe a specific key.
        if ((0, util_1.isPropertyKey)(keyOrOptions)) {
            (0, ecce_1.observe)(subject, keyOrOptions, rerender, options);
            return () => {
                (0, ecce_1.unobserve)(subject, keyOrOptions, rerender);
            };
        }
        // Observer entire subject.
        (0, ecce_1.observe)(subject, rerender);
        return () => {
            (0, ecce_1.unobserve)(subject, rerender);
        };
    }, [subject, keyOrOptions, options]);
};
exports.useSubject = useSubject;
//# sourceMappingURL=hooks.js.map